import { Stack } from '@mui/material';
import { Provider } from '@repo/api-gw-sdk';

import { RestoreRegionSelect } from '@/components/selectors/restoreRegionSelect';
import { SnapshotToolbar } from '@/components/snapshots/snapshotToolbar';
import type { StepProps } from '@/components/wizard/StepProps';
import { PreferencesKey } from '@/data/dal/preferencesKey';

import { StepContainer } from '../../wizard/StepContainer';
import { BucketSelectionStep } from '../bucketSelectionStep';
import type { RestoreEKSNamespaceState } from '../restoreEksNamespaceWizard';

export const EksNamespaceConfiguration = (
  props: StepProps<RestoreEKSNamespaceState>
) => {
  const { wizardState: stepState, stepperLabels, back } = props;
  const { S3 } = stepState;

  return (
    <StepContainer
      sx={{ padding: '0' }}
      stepperLabels={stepperLabels}
      stepperIndex={stepperLabels.length - 1}
      onBackClick={back}
      canGoNext={() => {
        return !!props.wizardState.region && Boolean(S3.Bucket);
      }}
      onNextClick={async () => props.setNextStep(props.currentStep.next?.[0])}
      toolbarComponent={
        <SnapshotToolbar
          pointInTime={props.wizardState.snapshot.pointInTime}
          vaultId={props.wizardState.snapshot.vaultId}
          accessDeniedItemsCount={
            props.wizardState.snapshot.accessDeniedItemsCount
          }
          supportPiTR={props.wizardState.snapshot.supportPiTR}
        />
      }
    >
      <Stack>
        <Stack className='mx-[40px] mt-[24px] w-1/2'>
          <RestoreRegionSelect
            cloudProvider={Provider.Aws}
            restoreAccountId={props.wizardState.restoreAccount?.id}
            regionName={props.wizardState.region}
            onChange={(region) =>
              props.setWizardState((state) => ({
                ...state,
                region,
              }))
            }
          />
        </Stack>
        <BucketSelectionStep
          {...props}
          preferencesKey={PreferencesKey.RestoreBucket}
        />
      </Stack>
    </StepContainer>
  );
};
